module.exports = __webpack_public_path__ + "static/media/service-trade-desktop.e643c84d.png";